// import store from "@/store/store";
// import BeCuponUtils from "@/utils/Utils";

export default class LoyaltyCampaing {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query{
          loyaltyCampaingRetrieve(id:${id}){
              id
              name
              active
              description
              dateStart
              dateEnd
              cantUso
              cantUsoCouponGift
              deal {
                id
                name
                description
              }
              raffles {
                id
                name
              }
              company {
                id
                name
              }
              fromCoupon {
                id
                title
              }
              toCoupon {
                id
                title
              }
              users{
                id
                username
                lastName
                email
                loyaltyCampaingsList{
                name
                  id
                  toCoupon{
                    id
                    title
                  }
                }
                promotionCouponUserList{
                  id
                  promotionCoupon{
                    id
                    created
                    coupon{
                      id
                      title
                      
                    }
                    totalPerUser
                  }
                }
              }
          }
        }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    var loyaltyCampaingRetrieve = response.data.data.loyaltyCampaingRetrieve;

    loyaltyCampaingRetrieve.compressed = {
      fromCoupon: loyaltyCampaingRetrieve.fromCoupon,
      toCoupon: loyaltyCampaingRetrieve.toCoupon,
      users: loyaltyCampaingRetrieve.users,
      deal: loyaltyCampaingRetrieve.deal,
      raffles: loyaltyCampaingRetrieve.raffles,
      company: loyaltyCampaingRetrieve.company
    };
    loyaltyCampaingRetrieve.raffles = loyaltyCampaingRetrieve.raffles?.id;
    loyaltyCampaingRetrieve.fromCoupon = loyaltyCampaingRetrieve.fromCoupon.id;
    loyaltyCampaingRetrieve.deal = loyaltyCampaingRetrieve.deal.id;
    loyaltyCampaingRetrieve.company = loyaltyCampaingRetrieve.company.id;

    loyaltyCampaingRetrieve.toCoupon = loyaltyCampaingRetrieve.toCoupon.map(node => node.id);
    loyaltyCampaingRetrieve.users = loyaltyCampaingRetrieve.users.map(node => node.id);


    for(var i = 0; i < loyaltyCampaingRetrieve.compressed.users.length; i++) {
      // loyaltyCampaingRetrieve.compressed.users[i].promotionCouponUserList = loyaltyCampaingRetrieve.compressed.users[i].promotionCouponUserList.map(node => node.id).join(' | ');
      var promotionCouponUserList = loyaltyCampaingRetrieve.compressed.users[i].promotionCouponUserList;
      for(var e = 0; e < promotionCouponUserList.length; e++) {
        loyaltyCampaingRetrieve.compressed.users[i].count = promotionCouponUserList.length;
        loyaltyCampaingRetrieve.compressed.users[i].promotionCouponUserList = promotionCouponUserList.map(node => node.promotionCoupon.coupon.title).join(' | ');
        loyaltyCampaingRetrieve.compressed.users[i].dateObtain = promotionCouponUserList.map(node => node.promotionCoupon.created).join(' | ');
      }
    }
    console.log("esto es lo que tenemos...", loyaltyCampaingRetrieve.compressed.users)
    return loyaltyCampaingRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        loyaltyCampaingList{
            results {
              id
              name
              active
              description
              dateStart
              dateEnd
              cantUso
              cantUsoCouponGift
              raffles {
              id
              name
              }
              deal {
                id
                name
                description
              }
              company {
                id
                name
              }
              fromCoupon {
                id
                title
              }
              toCoupon {
                id
                title
              }
              users{
                id
                username
                lastName
                email
                promotionCouponUserList{
                  id
                  promotionCoupon{
                    id
                    coupon{
                      id
                      title
                      
                    }
                    totalPerUser
                  }
                }
              }
            }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    var loyaltyCampaingList = response.data.data.loyaltyCampaingList.results.reverse();

    for(var i = 0; i < loyaltyCampaingList.length; i++) {
      loyaltyCampaingList[i].toCoupon = loyaltyCampaingList[i].toCoupon.map(node => node.title).join(' | ');
      loyaltyCampaingList[i].users = loyaltyCampaingList[i].users.map(node => node.username).join(' | ');
    }
    return loyaltyCampaingList;

    // return response.data.data.loyaltyCampaingList.results.reverse();
  }

  // static async filter(axios, active) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       couponList (active: ${active}){
  //         results{
  //           id
  //           isActive
  //           available
  //           amountCompleted
  //           amountActives
  //           title
  //           expirationDate
  //           globalTotalUses
  //           globalUses
  //           inWallet
  //           globalActives
  //           images {
  //             id
  //             url
  //           }
  //           initialDate
  //           dailyUses
  //           totalUses
  //           showApp
  //           assignedCoupon
  //           qrText
  //           company{
  //             id
  //             name
  //           }
  //           qrValidationCode
  //           qrValidationCodeUses
  //           totalClick
  //           qrBarcode {
  //             id
  //             url
  //           }
  //           coupons{
  //             id
  //             title
  //           }
  //           branchOffices{
  //             id
  //             name
  //           }
  //           couponsUses{
  //             id
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //
  //   return response.data.data.couponList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deletePromotion ($id: ID!){
          deletePromotion(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deletePromotion.ok;
  }
}
